import DateRangeAndGuests from './DateRangeAndGuests'
import ReservationAddons from 'Shared/Cart/CartSummary/ReservationAddons'

const ReservationContent = ({ displayIcon, reservation }) => {
  const { items } = reservation?.pricing || {}
  const itemsToShow = items?.filter(item => item.itemableType !== 'pricing_tier') || []

  return (
    <>
      <DateRangeAndGuests reservation={reservation} />

      <ReservationAddons addons={itemsToShow} boldText={false} className="my-2 text-muted"
                         displayIcon={displayIcon} />
    </>
  )
}

export default ReservationContent
